// PRC-032: estado vacío común (icono, título, una frase y la acción que lo resuelve).
import React from 'react';
import { Box } from '@mui/material';
import { J } from '../journeyTokens';
import { JourneyButton, JourneyText } from './JourneyBasics';

export interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  text?: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  // Otra acción ya construida (p. ej. un enlace), en lugar de actionLabel/onAction.
  action?: React.ReactNode;
  minHeight?: number;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, text, actionLabel, onAction, action, minHeight = 220 }) => (
  <Box sx={{ border: `1px dashed ${J.borderStrong}`, borderRadius: J.radiusCard, minHeight, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px', textAlign: 'center', p: 3, fontFamily: J.font }}>
    <Box sx={{ color: J.muted, display: 'flex', '& svg': { fontSize: 36 } }}>{icon}</Box>
    <JourneyText variant="h3">{title}</JourneyText>
    {text && <JourneyText variant="small" sx={{ maxWidth: 460 }}>{text}</JourneyText>}
    {action ?? (actionLabel && onAction && <JourneyButton small onClick={onAction}>{actionLabel}</JourneyButton>)}
  </Box>
);

export default EmptyState;
